<template>
    <div>
        <vxe-modal :title="dialogtitle"  :width="dialogWidth" height="80vh" className="showdialogClassName" destroy-on-close
        v-model="dialogkanBoardVisible" show-zoom resize  draggable>
        <div class="nofull-tool-result">
            
           <wc-kan-board  :kanBoardConfig="JSON.stringify(kanBoardConfig)" :satoken="satoken" :domain="domain"></wc-kan-board>
        </div>

    </vxe-modal>
    </div>
</template>


<script>
export default {
  data() {
    return {
      kanboardtype: "",
      dialogtitle: "",
      dialogWidth: "",
      dialogkanBoardVisible: false,
     
      satoken:localStorage.getItem( "USER_TOKEN_VAL" )|| "",
      domain:`${config.serverUrl}`,
      kanBoardConfig: {
        type: "ESG",

        headerConfig: { kanboardname: "小智分析-ESG", logo: "https://test.cmdp.cn/plus/plugins/web/img/site-logo.svg" ,menuConfig:[]},
        bodyConfig: {
            gridStackOptions: {
                margin: 5,
                column: 12,
                minRow: 1, // don't collapse when empty
                cellHeight: 120,
                disableOneColumnMode: true,
                float: true,
                removable: '.trash', // true or drag-out delete class
                itemClass: 'with-lines', // test a custom additional class #2110
                acceptWidgets: true
            },
            gridStackItem: [
                {
                    x: 0, y: 0, w: 8, h: 2, id: "", cardtitle: "", type: "card-grid", data: [
                        {
                            title: "环境(Environmental)", list: [
                                { text: "新增的点", number: 0, numclass: "" },
                                { text: "处理中的点", number: 0, numclass: "" },
                                { text: "改善的点", number: 0, numclass: "wc-num-primary" },
                                { text: "变差的点", number: 0, numclass: "wc-number-danger" },
                            ]
                        },
                        {
                            title: "社会(Social)", list: [
                                { text: "新增的点", number: 0, numclass: "" },
                                { text: "处理中的点", number: 0, numclass: "" },
                                { text: "改善的点", number: 0, numclass: "wc-num-primary" },
                                { text: "变差的点", number: 0, numclass: "wc-number-danger" },
                            ]
                        },
                        {
                            title: "治理(Governmance)", list: [
                                { text: "新增的点", number: 0, numclass: "" },
                                { text: "处理中的点", number: 0, numclass: "" },
                                { text: "改善的点", number: 0, numclass: "wc-num-primary" },
                                { text: "变差的点", number: 0, numclass: "wc-number-danger" },
                            ]
                        },
                    ]
                },
                {
                    x: 8, y: 0, w: 4, h: 2, type: "card-dataList",
                    cardtitle: "风险预警", src: "", data: []
                },
                { x: 0, y: 2, w: 8, h: 2, cardtitle: "测评概况（路孚特）", type: "card-vega", src: "", data: [{ src: "" }] },
                {
                    x: 8, y: 2, w: 4, h: 2, cardtitle: "智囊", type: "card-buttons", src: "", data: [
                        { text: "报告管理", icon: "mysvg:reportManage", code: "" },
                        { text: "智囊样例", icon: "mysvg:example", code: "" }
                    ]
                },
                { x: 0, y: 4, w: 8, h: 2, cardtitle: "", type: "card-tabs-files", src: "", config: { uploadLocalFilePath: "md/看板本地资料/ESG", uploadLocalFileType: "" }, data: [{ title: "本地资料" }, { title: "最新云资料" }] },
                { x: 8, y: 4, w: 4, h: 2, cardtitle: "日行情图", type: "card-image", src: "", data: [] }
            ]
        },
        footerConfig: {}
    },
    };
  },

  created() {
    let that = this;
    this.$EventBus.$on("opendialogkanBoard", e => {
      let _params = e._params;
      if (_params) {
        this.dialogtitle = _params.dialogtitle;
        this.dialogWidth = _params.dialogWidth;
        this.kanboardtype=_params.kanboardtype
      }
      this.dialogkanBoardVisible=true;
    //   that.$nextTick(() => {

    //   })
    });
  }
};
</script>

    